import { render, staticRenderFns } from "./FineBIPage.vue?vue&type=template&id=1fae8950&scoped=true"
import script from "./FineBIPage.vue?vue&type=script&lang=js"
export * from "./FineBIPage.vue?vue&type=script&lang=js"
import style0 from "./FineBIPage.vue?vue&type=style&index=0&id=1fae8950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae8950",
  null
  
)

export default component.exports